import { useEffect } from 'react'

import type { OrderFlowStep } from '@/app/[locale]/order/_constants/order-flow-steps.const'

/**
 * Scrolls the window to the top whenever the order funnel step changes (standard flow).
 */
export function useScrollToTopOnOrderStep(currentStep: OrderFlowStep) {
	useEffect(() => {
		window.scrollTo({ top: 0, behavior: 'instant' })
	}, [currentStep])
}
